import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { Suspense } from "react";

const EmojiPickerLazy = lazyWithRetry(
  () =>
    import(/* webpackChunkName: "EmojiPickerV4_EmojiPicker" */ "./EmojiPicker"),
);

interface EmojiPickerProps {
  dismiss: () => void;
}

export const EmojiPicker = (props: EmojiPickerProps) => (
  <Suspense fallback={<div className="h-[25rem]" />}>
    <EmojiPickerLazy {...props} />
  </Suspense>
);
